var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tailwind Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.65332C11.4477 7.65332 11 7.20561 11 6.65332C11 6.10104 11.4477 5.65332 12 5.65332H17C17.5523 5.65332 18 6.10104 18 6.65332V11.6533C18 12.2056 17.5523 12.6533 17 12.6533C16.4477 12.6533 16 12.2056 16 11.6533V9.06753L11.7071 13.3604C11.3166 13.751 10.6834 13.751 10.2929 13.3604L8 11.0675L3.70711 15.3604C3.31658 15.751 2.68342 15.751 2.29289 15.3604C1.90237 14.9699 1.90237 14.3367 2.29289 13.9462L7.2929 8.94621C7.68342 8.55569 8.31659 8.55569 8.70711 8.94621L11 11.2391L14.5858 7.65332H12Z",
    fill: "#17C964"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon2);
export default __webpack_public_path__ + "static/media/history-icon-2.96725f1fb48ca3b3ff2b15a357539953.svg";
export { ForwardRef as ReactComponent };